import React from 'react'
import classNames from 'classnames'

const getErrorTextForType = (error) => {

  if (error.result && error.result.then) {
    return 'pending...'
  }

  return ('result' in error && error.result)
    ? error.result
    : error.type
}

const renderErrorList = (errors) => {
  return (
    <ul>
      {(errors || []).map((error) => {
        const key = `validation-error-${error.type}-${error.result}`
        return (
          <li key={key}>
            {getErrorTextForType(error)}
          </li>
        )
      })}
    </ul>
  )
}

export default
function ValidationText({ children, isValid }) {
  return isValid !== undefined
    ? (
      <div
        className={classNames('help-block', 'validation-text', {
          valid: isValid.valid
        })}
      >
        {children}
        {renderErrorList(isValid.errors)}
      </div>
    )
    : null
}



// WEBPACK FOOTER //
// ./src/shared/components/ValidationText.js